import { Injectable } from '@angular/core';
import { IQuotation } from '@simplyfly/shared';
import { FirestoreService } from '../firestore/firestore.service';

@Injectable({
  providedIn: 'root'
})
export class QuotationFirestoreService extends FirestoreService<IQuotation> {
  protected basePath = 'quotations';
}
